import { NotificationDomain, NotificationsCatalogData, Service } from '@repo/core'
import { AxiosInstance } from 'axios'

export const getNotificationsConfig: Service<
  { domain: NotificationDomain },
  NotificationsCatalogData
> = async ({ api, params }: { api: AxiosInstance; params: { domain: NotificationDomain } }) => {
  const { domain } = params
  return await api.get<NotificationsCatalogData>(`notifications/${domain}/notifications.json`)
}
